// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__HH544","content":"LayoutSettings_content__3726x"};